import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Alert from '../../../shared/components/Alert';

class ProductModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    postValue: PropTypes.objectOf(PropTypes.string),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    title: 'Product',
    modal: false,
    color: 'primary',
    postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
  };

  constructor() {
    super();
    this.state = {};
    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      color, title, modal, toggle, handleChange, postValue, handleSubmit, errorMsg,
    } = this.props;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title.toString()}</h4>
          </div>
          <form id="product_form" onSubmit={handleSubmit}>
            <div className="modal__body p-t-10">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group m-b-0">
                  <span className="form__form-group-label">Product Name <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="productName" value={postValue.productName ? postValue.productName : ''} placeholder="Product Name" onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color={color}>Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'ProductModal', // a unique identifier for this form
})(ProductModal);
